import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Fallbacks ensure external preview and published builds work even if the
// build-time env injection is missing. The publishable (anon) key is safe to
// expose; RLS enforces actual security.
const FALLBACK_URL = "https://huxeknkddlrffeterchr.supabase.co";
const FALLBACK_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh1eGVrbmtkZGxyZmZldGVyY2hyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE4MzMwMzQsImV4cCI6MjA3NzQwOTAzNH0.u74YfE_IRRexzL6Xgof-dnUppi0pkKELSpe1Wc64JOw";

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || FALLBACK_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || FALLBACK_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});